/**
 * Decorative folk-art rule shown at the top of every page when a Folio
 * theme is active. Hidden via CSS (display:none) under any other theme,
 * so it costs nothing to mount globally.
 */
export function FolioStrip() {
  return (
    <div className="folio-strip" aria-hidden="true">
      <Sparkle size={12} color="hsl(var(--folio-mustard))" />
      <Clover size={14} color="hsl(var(--primary))" />
      <span className="line" />
      <Flower size={14} color="hsl(var(--folio-rose))" />
      <Sparkle size={14} color="hsl(var(--folio-mustard))" />
      <Flower size={14} color="hsl(var(--folio-sage))" />
      <span className="line" />
      <Clover size={14} color="hsl(var(--folio-slate))" />
      <Sparkle size={12} color="hsl(var(--folio-mustard))" />
    </div>
  )
}

function Sparkle({ size, color }: { size: number; color: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" className="shrink-0">
      <path d="M10 1 L11.5 8.5 L19 10 L11.5 11.5 L10 19 L8.5 11.5 L1 10 L8.5 8.5 Z" fill={color} />
    </svg>
  )
}

function Flower({ size, color }: { size: number; color: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className="shrink-0">
      <circle cx="12" cy="6" r="3.2" fill={color} />
      <circle cx="18" cy="12" r="3.2" fill={color} />
      <circle cx="12" cy="18" r="3.2" fill={color} />
      <circle cx="6" cy="12" r="3.2" fill={color} />
      <circle cx="12" cy="12" r="2" fill="hsl(var(--background))" />
    </svg>
  )
}

function Clover({ size, color }: { size: number; color: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className="shrink-0">
      <path d="M12 12 C12 6, 8 4, 6 6 C4 8, 6 12, 12 12 Z" fill={color} />
      <path d="M12 12 C18 12, 20 8, 18 6 C16 4, 12 6, 12 12 Z" fill={color} />
      <path d="M12 12 C12 18, 8 20, 6 18 C4 16, 6 12, 12 12 Z" fill={color} />
      <path d="M12 12 C18 12, 20 16, 18 18 C16 20, 12 18, 12 12 Z" fill={color} />
    </svg>
  )
}
